import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from 'primereact/menu'
import type { MenuItem } from 'primereact/menuitem'
import Button from '../../../components/ui/Button'
import type { MeetingGroup } from '../types'

interface Props {
  row: MeetingGroup
  onEdit: (row: MeetingGroup) => void
  onDelete: (row: MeetingGroup) => void
  /** İşlem süren satır — yalnız o satırın menüsü kilitlenir (078-b `busyId` deseni). */
  busy: boolean
}

/**
 * Mobil kart satır işlemleri — 3 nokta (kebab) ile açılan popup menü (`DeadlineRequestRowActions`
 * emsali; kullanıcı isteği: iki ayrı ikon butonu yerine tek dropdown).
 */
export default function MeetingGroupRowActions({ row, onEdit, onDelete, busy }: Readonly<Props>) {
  const { t } = useTranslation()
  const menuRef = useRef<Menu>(null)

  const items: MenuItem[] = [
    {
      label: t('meetings.actions.edit'),
      icon: 'pi pi-pencil',
      command: () => onEdit(row),
    },
    {
      label: t('meetings.actions.delete'),
      icon: 'pi pi-trash',
      command: () => onDelete(row),
    },
  ]

  return (
    <>
      {/* Panel kartın DIŞINA çizilir: kart içinde kalırsa son satırlarda kırpılır. */}
      <Menu model={items} popup ref={menuRef} appendTo={document.body} />
      <Button
        type="button"
        text
        rounded
        icon="pi pi-ellipsis-v"
        aria-label={t('meetings.actions.actionsMenu')}
        aria-haspopup
        disabled={busy}
        onClick={(e) => menuRef.current?.toggle(e)}
      />
    </>
  )
}
